import { render } from "./CodeViewModule.vue?vue&type=template&id=478e36b6"
import script from "./CodeViewModule.vue?vue&type=script&lang=js"
export * from "./CodeViewModule.vue?vue&type=script&lang=js"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__